import axios from 'axios'
import { useFlameStore } from '@/stores/useFlameStore'

export async function sacredAxios(path: string, data: any, tokenOverride: string) {
    const flameToken = tokenOverride || useFlameStore().flameToken

    try {
        const response = await axios.post(path, data, {
            headers: {
                'Content-Type': 'application/json',
                'X-Flame-Token': flameToken
            }
        })
        return { success: true, data: response.data }
    } catch (err: any) {
        const message =
            err?.response?.data?.error ||
            err?.message ||
            '⚠️ A silence answered back.'
        return { success: false, error: message }
    }
}
